import React from "react";
import logo from "./img/enjuggernaut_logo.png";
import { useNavigate } from "react-router-dom";

export function Done() {
  const navigate = useNavigate();

  const navigateHome = () => {
    navigate("/");
  };

  return (
    <div className="dark-panel min-h-screen max-w-full">
      <header className="header sticky flex items-center justify-between p-4">
        <img src={logo} className="h-auto w-1/4" alt="logo" />
      </header>

      <div className="py-10 font-code lg:px-10 xl:p-20 xl:px-60">
        <h1 className="welcome-text pt-8 text-4xl font-bold md:text-6xl lg:text-7xl xl:pt-14 2xl:text-9xl">
          <span className="text-orange">That&apos;s it!</span>
        </h1>

        <h1 className="welcome-text pt-8 text-2xl font-bold md:text-4xl lg:text-5xl xl:pt-14 2xl:text-7xl">
          <span className="text-blue">
            Your profile will be sent to you soon!
          </span>
        </h1>

        <div className="mt-10 flex h-1/4 items-center justify-center lg:mt-20">
          <button
            className="start-button px-4 py-2 text-lg font-bold md:py-4 md:text-xl lg:text-3xl xl:text-5xl 2xl:text-6xl"
            onClick={navigateHome}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
